export const NSHIFT_CLIENT_ID = process.env.NSHIFT_CLIENT_ID
export const NSHIFT_CLIENT_SECRET = process.env.NSHIFT_CLIENT_SECRET
export const NSHIFT_CHECKOUT_CONNECTION_ID = process.env.NSHIFT_CHECKOUT_CONNECTION_ID
export const NSHIFT_CHECKOUT_API_URL = process.env.NSHIFT_CHECKOUT_API_URL
